import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  copyButton: {
    marginTop: theme.spacing(1),
  },
  dateText: {
    color: theme.palette.text.secondary,
    fontSize: '0.75rem',
  },
  errorText: {
    color: theme.palette.error.main,
  },
  triggerContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginBottom: theme.spacing(1),
  },
}))

export default useStyles
